/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import RequestService from '../service/requestService';
import * as actionTypes from './actionTypes';
import * as actions from './actions';

export const fetchingConsentDocuments4SoPChangeAnswers = () => {
  return {
    type: actionTypes.FETCHING_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS
  };
};

export const fetchedConsentDocumentsForSoP = (document) => {
  return {
    type: actionTypes.FETCHED_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS,
    payload: document
  };
};

export const fetchedConsentingOptInState4SoPChangeAnswers = (consentingOptInOptOut) => {
  return {
    type: actionTypes.FETCHED_CONSENTING_OPTIN_STATE_4_SOP_CHANGE_ANSWERS,
    payload: consentingOptInOptOut
  };
};

export const showError4SoPChangeAnswers = (error) => {
  return {
    type: actionTypes.SHOW_ERROR_4_SOP_CHANGE_ANSWERS,
    payload: error
  };
};

export const clearConsentDocuments4SoPChangeAnswers = () => {
  return {
    type: actionTypes.CLEAR_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS
  };
};

export function fetchConsentingOptInState4SoPChangeAnswers(consentId) {
  return (dispatch) => {
    dispatch(fetchingConsentDocuments4SoPChangeAnswers());
    return RequestService.getConsentingOptInState(consentId)
      .then((response) => {
        dispatch(fetchedConsentingOptInState4SoPChangeAnswers(response.data));
      })
      .catch((error) => {
        dispatch(showError4SoPChangeAnswers(error));
      });
  };
}

export function fetchConsentDocument4SoPChangeAnswers(consentGid) {
  return function (dispatch) {
    dispatch(fetchingConsentDocuments4SoPChangeAnswers());
    return RequestService.getConsentDocumentForParticipant(consentGid)
      .then((response) => {
        dispatch(fetchedConsentDocumentsForSoP(response));
      })
      .catch((error) => {
        dispatch(showError4SoPChangeAnswers(error));
      });
  };
}

export function saveChangeAnswers(payload) {
  const {
    consentingGid,
    studyGid: studyId,
    participantId,
    signatureDate,
    reason,
    choiceAnswers,
    addendumFile
  } = payload;

  const formData = new FormData();
  formData.append('reason', reason);
  formData.append('signatureDate', signatureDate);
  formData.append('choiceAnswers', JSON.stringify(choiceAnswers));
  addendumFile && formData.append('addendum', addendumFile);

  return function (dispatch) {
    return RequestService.postChangeAnswers(consentingGid, formData)
      .then((response) => {
        dispatch(actions.fetchDocuments({ studyId, participantId }));
        dispatch(actions.hideModal());
        dispatch(clearConsentDocuments4SoPChangeAnswers());
      })
      .catch((err) => {
        dispatch(showError4SoPChangeAnswers(err));
      });
  };
}
